/**
 * DocContent - Renders documentation content from HTML string.
 * Used for content with special chars (e.g. Magik <<) that break JSX.
 */
import React from "react";

export default function DocContent({ html, className = "" }) {
  return (
    <div
      className={`doc-content prose prose-gray dark:prose-invert max-w-none ${className}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
